/* ==========================================================================
   TUCANO · Newsletter popup
   Delay + primo accesso (localStorage) + submit AJAX al form 'customer'.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-tcn-nl]');
  if (!root) return;

  var SEEN_KEY = 'tcn_nl_seen';
  var SUB_KEY = 'tcn_nl_subscribed';
  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  var forcePreview = /[?&]tcn_nl=/.test(window.location.search);

  var FIRST_KEY = 'tcn_nl_first_visit';
  function ckGet(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? m[1] : null; }
  function ckSet(k, v) { try { document.cookie = k + '=' + v + '; path=/; max-age=31536000; SameSite=Lax'; } catch (e) {} }
  function lsGet(k) { var v = null; try { v = localStorage.getItem(k); } catch (e) {} return v || ckGet(k); }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} ckSet(k, v); }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // Solo alla PRIMA apertura del sito: la prima visita viene registrata subito (non solo quando
  // il popup compare). Il popup può comparire solo durante quella prima sessione di navigazione.
  if (!isDesignMode && !forcePreview) {
    if (lsGet(SEEN_KEY) || lsGet(SUB_KEY)) return;
    if (!lsGet(FIRST_KEY)) { lsSet(FIRST_KEY, '1'); ssSet(FIRST_KEY, '1'); }
    else if (!ssGet(FIRST_KEY)) { lsSet(SEEN_KEY, '1'); return; }
  }

  var card = root.querySelector('[data-tcn-nl-card]');
  var form = root.querySelector('[data-tcn-nl-form]');
  var emailInput = root.querySelector('[data-tcn-nl-email]');
  var errorEl = root.querySelector('[data-tcn-nl-error]');
  var submitBtn = root.querySelector('[data-tcn-nl-submit]');
  var formView = root.querySelector('[data-tcn-nl-view="form"]');
  var successView = root.querySelector('[data-tcn-nl-view="success"]');
  var tagsInput = root.querySelector('input[name="contact[tags]"]');
  var delayMs = (parseInt(root.getAttribute('data-tcn-nl-delay'), 10) || 10) * 1000;

  var shown = false;

  function markSeen() { if (!isDesignMode && !forcePreview) lsSet(SEEN_KEY, '1'); }

  function show() {
    if (shown) return;
    shown = true;
    root.hidden = false;
    // doppio rAF per far partire la transizione d'entrata
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-shown'); });
    });
    markSeen();
    document.addEventListener('keydown', onKey);
  }

  function hide() {
    root.classList.remove('is-shown');
    document.removeEventListener('keydown', onKey);
    var done = false;
    var finish = function () { if (done) return; done = true; root.hidden = true; };
    card.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 700); // fallback
  }

  function onKey(e) { if (e.key === 'Escape') hide(); }

  // Chiusura manuale
  Array.prototype.forEach.call(root.querySelectorAll('[data-tcn-nl-close]'), function (btn) {
    btn.addEventListener('click', hide);
  });

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  // Submit AJAX al form 'customer' di Shopify
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailInput.value || '').trim();
      if (errorEl) errorEl.hidden = true;

      if (!validEmail(email)) {
        if (errorEl) { errorEl.textContent = 'Inserisci un indirizzo email valido.'; errorEl.hidden = false; }
        emailInput.focus();
        return;
      }

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;

      var body = new FormData();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[tags]', (tagsInput && tagsInput.value) || 'newsletter,popup');
      body.append('contact[email]', email);

      var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(url, { method: 'POST', body: body, headers: { 'Accept': 'text/html' } })
        .then(function () { onSuccess(); })
        .catch(function () {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
          if (errorEl) { errorEl.textContent = 'Qualcosa è andato storto. Riprova.'; errorEl.hidden = false; }
        });
    });
  }

  function onSuccess() {
    if (!forcePreview) lsSet(SUB_KEY, '1');
    markSeen();
    if (formView) formView.hidden = true;
    if (successView) successView.hidden = false;
    root.classList.add('is-success');
    // conferma → poi sparisce
    setTimeout(hide, 4500);
  }

  // Copia codice sconto
  var copyBtn = root.querySelector('[data-tcn-nl-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-tcn-nl-copy');
      var label = copyBtn.textContent;
      var ok = function () {
        copyBtn.classList.add('is-copied');
        copyBtn.textContent = 'copiato ✓';
        setTimeout(function () { copyBtn.textContent = label; copyBtn.classList.remove('is-copied'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok).catch(function () {});
      }
    });
  }

  // Non sovrapporsi al cookie banner: aspetta che sia chiuso prima di apparire
  function cookieBannerVisible() {
    var c = document.querySelector('[data-tcn-cookies]');
    return !!(c && !c.hidden && c.offsetParent !== null);
  }

  function scheduleShow() {
    if (isDesignMode || forcePreview) { setTimeout(show, 400); return; } // editor / ?tcn_nl=1: anteprima rapida
    setTimeout(function tryShow() {
      if (cookieBannerVisible()) { setTimeout(tryShow, 1500); return; }
      show();
    }, delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleShow);
  } else {
    scheduleShow();
  }
})();
